import { alertsConstants } from "../_constants";
import { alertsService } from "../_services";
import { alertActions } from "./";
//import { history } from '../_helpers';

export const alertsActions = {
  getDetail,
  setFeedback,
  setCorrect
};

function getDetail(dependant_user_id, timestamp) {
  return dispatch => {
    dispatch(request());

    alertsService.getDetail(dependant_user_id, timestamp).then(
      detail => {
        dispatch(success(detail));
      },
      error => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request() {
    return { type: alertsConstants.DETAIL_REQUEST };
  }
  function success(detail) {
    return { type: alertsConstants.DETAIL_SUCCESS, detail };
  }
  function failure(error) {
    return { type: alertsConstants.DETAIL_FAILURE, error };
  }
}

function setCorrect(user, correct, id, timestamp) {
  return dispatch => {
    dispatch(request());

    alertsService.setCorrect(user, correct, id, timestamp).then(
      detail => {
        dispatch(success(detail));
      },
      error => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request() {
    return { type: alertsConstants.CORRECT_REQUEST };
  }
  function success(detail) {
    return { type: alertsConstants.CORRECT_SUCCESS, detail };
  }
  function failure(error) {
    return { type: alertsConstants.CORRECT_FAILURE, error };
  }
}

function setFeedback(user, feedback, id, timestamp) {
  return dispatch => {
    dispatch(request());

    alertsService.setFeedback(user, feedback, id, timestamp).then(
      detail => {
        dispatch(success(detail));
      },
      error => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request() {
    return { type: alertsConstants.FEEDBACK_REQUEST };
  }
  function success(detail) {
    return { type: alertsConstants.FEEDBACK_SUCCESS, detail };
  }
  function failure(error) {
    return { type: alertsConstants.FEEDBACK_FAILURE, error };
  }
}
